import { Spacer } from "components/views/atoms/Atoms"
import { Body } from "components/views/atoms/Bodies"
import { AuthCard, AuthLayout } from "components/views/login/Shared"
import React, { useEffect } from "react"
import L10n from "lib/carrot-l10n"
import { useSignUpFlow } from "../context/signup/SignUpFlowContext"
import { ButtonPrimary } from "../views/atoms/buttons/ButtonPrimary"
import { useHistory } from "react-router"
import { H1 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

export default function SignUpEmployeeAlreadyRegisteredPage() {
  const { email } = useSignUpFlow()
  const history = useHistory()

  useEffect(() => {
    if (!email) {
      history.push("/signup")
    }
  }, [])
  return (
    <AuthLayout title="It looks like you already have an account">
      <AuthCard>
        <Spacer height={4} />
        <div className="flex flex-row justify-center">
          <H1>{l`It looks like you already `}</H1>
        </div>
        <div className="flex flex-row justify-center">
          <H1>{l`have an account`}</H1>
        </div>
        <Spacer height={0.5} />
        <Body color="black-80" align="tc">
          {l`We found an account for `}
          {email}.
        </Body>
        <Spacer height={1} />
        <Body color="black-80" align="tc">
          {l`Please try logging in with the email above.`}
        </Body>
        <Spacer height={3} />
        <div className="flex flex-row justify-center">
          <ButtonPrimary to={"/login"}>{l`Go to login`}</ButtonPrimary>
        </div>
        <Spacer height={3} />
      </AuthCard>
    </AuthLayout>
  )
}
